class MainProductManager {
  constructor() {
    this.isInitialized = false;
    this.isDataReady = false;
    this.isProcessing = false;

    // 数据状态
    this.mediaGroups = null;
    this.currentVariant = null;
    this.currentMediaData = null;

    this.mediaGallery = null;
    this.productInfo = null;
    this.variantSelects = null;

    this.variantChangeHandler = this.handleVariantChange.bind(this);
  }

  async initialize() {
    if (this.isInitialized) {
      return;
    }

    try {
      await this.waitForPreGroupingData();

      this.getComponentReferences();

      this.setupEventListeners();

      await this.initializeComponents();

      this.isDataReady = true;
      this.isInitialized = true;

      this.dispatchDataReadyEvent();
    } catch (error) {
      console.error("主产品管理器初始化失败:", error);
    }
  }

  getCurrentVariantFromPage() {
    try {
      if (this.variantSelects && typeof this.variantSelects.getCurrentVariant === "function") {
        return this.variantSelects.getCurrentVariant();
      }
      const input = document.querySelector(
        '.product-form input[name="id"], form[data-type="add-to-cart-form"] input[name="id"]'
      );
      const sectionEl = document.querySelector(
        ".product-info-container [data-section-id], .product-info-container [data-section]"
      );
      const sectionId = sectionEl && (sectionEl.getAttribute("data-section-id") || sectionEl.getAttribute("data-section"));
      const jsonEl = sectionId ? document.getElementById("ProductJson-" + sectionId) : null;
      if (!input || !jsonEl) return null;
      const product = JSON.parse(jsonEl.textContent || "{}");
      const variantId = parseInt(input.value, 10);
      if (!product.variants || !variantId) return null;
      return product.variants.find((v) => parseInt(v.id, 10) === variantId) || null;
    } catch (e) {
      return null;
    }
  }

  async waitForPreGroupingData() {
    return new Promise((resolve) => {
      const checkPreGrouping = () => {
        if (
          window.productMediaPreGrouping &&
          window.productMediaPreGrouping.isInitialized
        ) {
          this.mediaGroups = window.productMediaPreGrouping.mediaGroups;
        }
        resolve();
      };
      checkPreGrouping();
    });
  }

  getComponentReferences() {
    const mediaGalleryElement = document.querySelector("media-gallery");
    if (mediaGalleryElement) {
      this.mediaGallery = mediaGalleryElement;
    }

    const productInfoElement = document.querySelector("product-info");
    if (productInfoElement) {
      this.productInfo = productInfoElement;
    }

    const variantSelectsElement = document.querySelector("variant-selects");
    if (variantSelectsElement) {
      this.variantSelects = variantSelectsElement;
    }
  }

  setupEventListeners() {
    document.addEventListener("variant:change", this.variantChangeHandler);
    document.addEventListener("variant:changed", this.variantChangeHandler);
  }
  async initializeComponents() {
    if (this.mediaGallery) {
    }
    if (this.productInfo) {
    }
  }
  async handleVariantChange(event) {
    if (this.isProcessing) {
      return;
    }

    const variant = event.detail?.variant;
    if (!variant) {
      return;
    }
    if (this.currentVariant && this.currentVariant.id === variant.id) {
      return;
    }

    this.isProcessing = true;

    try {
      this.currentVariant = variant;

      const mediaData = this.getMediaDataForVariant(variant);

      await this.updateMediaGallery(mediaData, variant);

      this.updateProductInfo(variant);
    } catch (error) {
      console.error("处理变体变化失败:", error);
    } finally {
      this.isProcessing = false;
    }
  }

  getMediaDataForVariant(variant) {
    if (!variant || !window.productMediaPreGrouping?.isInitialized) {
      return [];
    }

    try {
      const currentMedia =
        window.productMediaPreGrouping.getCurrentVariantMedia();
      if (currentMedia?.length > 0) {
        return currentMedia;
      }

      const combinationKey =
        window.productMediaPreGrouping.createCombinationKey(variant);
      const combinations = window.productMediaPreGrouping.getAllCombinations();
      const combination = combinations?.[combinationKey];

      return combination?.media || [];
    } catch (error) {
      return [];
    }
  }

  async updateMediaGallery(mediaData, variant) {
    if (!this.mediaGallery || !mediaData?.length) {
      return;
    }

    try {
      this.currentMediaData = mediaData;

      this.mediaGallery.handleMediaDataUpdate(mediaData, variant);
    } catch (error) {
      console.error("更新媒体轮播图失败:", error);
    }
  }

  updateProductInfo(variant) {
    if (!this.productInfo || !variant) {
      return;
    }

    try {
      if (this.productInfo.renderPrice) {
        this.productInfo.renderPrice(variant);
      }

      if (this.productInfo.renderBuyButton) {
        this.productInfo.renderBuyButton(variant);
      }

      if (this.productInfo.syncVariantId) {
        this.productInfo.syncVariantId(variant.id);
      }
    } catch (error) {
      console.error("更新产品信息失败:", error);
    }
  }

  dispatchDataReadyEvent() {
    const event = new CustomEvent("mainProductDataReady", {
      detail: {
        mediaGroups: this.mediaGroups,
        currentVariant: this.currentVariant,
        currentMediaData: this.currentMediaData,
      },
      bubbles: true,
    });

    document.dispatchEvent(event);
  }

  getStatus() {
    return {
      isInitialized: this.isInitialized,
      isDataReady: this.isDataReady,
      isProcessing: this.isProcessing,
      hasMediaGroups: !!this.mediaGroups,
      hasCurrentVariant: !!this.currentVariant,
      hasCurrentMediaData: !!this.currentMediaData,
      hasMediaGallery: !!this.mediaGallery,
      hasProductInfo: !!this.productInfo,
      hasVariantSelects: !!this.variantSelects,
    };
  }

  destroy() {
    document.removeEventListener("variant:change", this.variantChangeHandler);
    document.removeEventListener("variant:changed", this.variantChangeHandler);

    this.mediaGallery = null;
    this.productInfo = null;
    this.variantSelects = null;
    this.mediaGroups = null;
    this.currentVariant = null;
    this.currentMediaData = null;

    this.isInitialized = false;
    this.isDataReady = false;
    this.isProcessing = false;
  }
}

window.mainProductManager = new MainProductManager();

document.addEventListener("DOMContentLoaded", () => {
  window.mainProductManager.initialize();
});

if (typeof module !== "undefined" && module.exports) {
  module.exports = MainProductManager;
}
